<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/courses/form' }">
        <a-button type="primary" icon="plus">
          新建课程
        </a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
            <a-button
              type="link"
              @click="() => (this.search = !this.search)"
            >高级筛选<a-icon
              :type="search ? 'up' : 'down'"
            /></a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="课程分类" block style="padding-bottom: 11px;">
            <a-form-item>
              <a-spin :spinning="categoriesLoad">
                <tag-select
                  v-if="categoriesList && categoriesList.length > 0"
                  v-model="params.where.category"
                  @change="getLists()"
                >
                  <tag-select-option
                    :value="item.id"
                    :key="index"
                    v-for="(item, index) in categoriesList"
                  >{{ item.name }}</tag-select-option
                  >
                </tag-select>
              </a-spin>
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="创建时间" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment().startOf('month'), moment()]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="value => handleChangeDate(value)"
              />
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="排序" grid>
            <a-row :gutter="24">
              <a-col class="gutter-row" :sm="{ span: 24 }" :lg="{ span: 18 }">
                <a-form-item>
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">
                      ID
                    </a-radio-button>
                    <a-radio-button value="sort">
                      排序
                    </a-radio-button>
                    <a-radio-button value="created_at">
                      创建时间
                    </a-radio-button>
                    <a-radio-button value="updated_at">
                      修改时间
                    </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col class="gutter-row" :sm="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-item>
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">
                      升序
                    </a-select-option>
                    <a-select-option value="desc">
                      降序
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>

        </template>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">正常</a-radio-button>
          <a-radio-button value="2">下架</a-radio-button>
        </a-radio-group>
      </div>
      <a-list size="default" :loading="loading" :pagination="pagination">
        <a-list-item :key="index" v-for="(item, index) in list">
          <a-list-item-meta>
            <viewer slot="avatar" class="link-pic">
              <a-avatar :size="150" shape="square" :src="globalUrl + item.thumb" v-if="item.thumb" />
              <span class="tag-type"><a-tag color="blue">{{ item.category.name }}</a-tag></span>
            </viewer>
            <h3 slot="title" class="title">
              <p>{{ item.title }}</p>
              <p class="sub-title">{{ item.title_en }}</p>
            </h3>
            <template slot="description">
              <div class="list-items">
                <span>
                  <a-icon type="pay-circle" />：<a-tag color="red"> ￥ {{ (item.price / 100) | NumberFormat }}</a-tag>
                </span>
                <span>
                  <a-icon type="calendar" />：<a-tag color="green">{{ moment(item.updated_at).fromNow() }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <span>
                  排序：<a-tag color="blue">{{ item.sort }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <a-tag style="margin-bottom: .75rem" v-for="(keyword, key) in (item.keywords || '').split(',')" :key="key">{{
                  keyword
                }}</a-tag>
              </div>
            </template>
          </a-list-item-meta>
          <div class="list-content" v-action:state>
            <div class="list-content-item">
              <a-switch
                checked-children="展示"
                un-checked-children="隐藏"
                :checked="item.state === 1"
                @change="handleChangeState(item.id)"
              />
            </div>
          </div>
          <div slot="actions" v-action:update>
            <a @click="handleSelectExam(item.id)">选择试卷</a>
          </div>
          <div slot="actions" v-action:update>
            <router-link :to="'/courses/form/' + item.id">
              <a>编辑</a>
            </router-link>
          </div>
          <div slot="actions" v-action:delete>
            <a-popconfirm title="确定要删除吗？" @confirm="handleOnDelete(item.id)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, card, select } from '@/mixins' // 引入
import { TagSelect, StandardFormRow } from '@/components'
import ModelForm from './modules/ModelForm'

const TagSelectOption = TagSelect.Option

const apiList = {
    getList: '/courses',
    changeState: '/courses/',
    delete: '/courses/',
    categoriesList: '/courses/categories/select'
}

export default {
    name: 'CourseList',
    mixins: [list, card, select], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow,
        ModelForm
    },
    data () {
        return {
            apiList,
            categoriesList: [],
            categoriesLoad: false
        }
    },
    mounted () {
        this.getLists() // 获取列表
        this.getSelectLists({
            url: apiList.categoriesList,
            type: 'categoriesList',
            load: 'categoriesLoad'
        })
    },
    methods: {
        handleSelectExam (id) {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    id,
                    on: {
                        ok () {
                            that.getLists()
                        },
                        cancel () {
                            console.log('cancel 回调')
                        },
                        close () {
                            console.log('modal close 回调')
                        }
                    }
                },
                {
                    title: '结业测试',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less">
.title {
    p {
        margin-bottom: .5rem;
    }
    .sub-title {
        font-size: .875rem;
    }
}
.tag-type {
    position: absolute;
    left: 0;
}
</style>
